import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@digdir/designsystemet-react';
import { ChevronLeftDoubleIcon, ChevronRightDoubleIcon } from '@navikt/aksel-icons';
import cn from 'classnames';

import { WebStorage } from '../../utils/WebStorage';
import { LogoHeader } from '../LogoHeader';
import itemClasses from '../SidebarItem/SidebarItem.module.css';
import { SidebarContent } from './SidebarContent';
import classes from './Sidebar.module.css';

export const SIDEBAR_COLLAPSED_KEY = 'sidebarCollapsed';

const getStorage = () => {
  try {
    return new WebStorage(window.localStorage);
  } catch {
    return null;
  }
};

/** Sidemeny (desktop). Kan minimeres til bare ikoner; valget huskes i nettleseren. */
export const Sidebar = () => {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState<boolean>(
    () => getStorage()?.getItem<boolean>(SIDEBAR_COLLAPSED_KEY) === true,
  );

  const toggle = () => {
    const next = !collapsed;
    setCollapsed(next);
    getStorage()?.setItem(SIDEBAR_COLLAPSED_KEY, next);
  };

  const toggleLabel = collapsed ? t('sidebar.expand') : t('sidebar.collapse');
  const ToggleIcon = collapsed ? ChevronRightDoubleIcon : ChevronLeftDoubleIcon;

  const toggleButton = (
    <button
      type="button"
      className={cn('ds-focus', itemClasses.item, itemClasses.small, {
        [itemClasses.collapsed]: collapsed,
      })}
      onClick={toggle}
    >
      <span className={itemClasses.icon}>
        <ToggleIcon aria-hidden />
      </span>
      <span className={cn(itemClasses.label, { 'ds-sr-only': collapsed })}>{toggleLabel}</span>
    </button>
  );

  return (
    <div
      className={cn(classes.sidebar, { [classes.sidebarCollapsed]: collapsed })}
      data-color="accent"
      data-print="false"
    >
      <div className={classes.logo}>
        <LogoHeader collapsed={collapsed} />
      </div>
      <SidebarContent collapsed={collapsed} />
      <div className={classes.toggle}>
        {collapsed ? (
          <Tooltip content={toggleLabel} placement="right">
            {toggleButton}
          </Tooltip>
        ) : (
          toggleButton
        )}
      </div>
    </div>
  );
};
